/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesCoursesApplicationCourseStatsCourseSectionStatsResponse { 
    par?: number;
    yardage?: number;
    scores: Array<number>;
    avg: Array<number>;
    aces: Array<number>;
    eagles: Array<number>;
    birdies: Array<number>;
    pars: Array<number>;
    bogeys: Array<number>;
    dblBogeys: Array<number>;
    others: Array<number>;
    fwys: Array<number>;
    fwysPct: Array<number>;
    grns: Array<number>;
    grnsPct: Array<number>;
    ssMade: Array<number>;
    ssAtt: Array<number>;
    ssPct: Array<number>;
    avgPutts: Array<number>;
}